// removed by extract-text-webpack-plugin
module.exports = {"spacesize-z":"0px","spacesize-xs":"16px","spacesize-s":"24px","spacesize-m":"48px","spacesize-l":"72px","spacesize-xl":"96px","spacesize-xxl":"144px","s":"(min-width: 34em)","m":"(min-width: 48em)","l":"(min-width: 64em)","xl":"(min-width: 75em)"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout.css
// module id = 500
// module chunks = 2